export default {

  // 积分商品列表
  getIntegralList(params, success) {
    Request.GET('/commodity/points', params, response => success(response));
  },

  // 查询积分商品详情
  getIntegralDetail(id, success) {
    Request.GET(`/commodity/points/${id}`, null, response => success(response));
  },

  // 删除积分商品
  deleteIntegral(id, success) {
    Request.DEL(`/commodity/points/${id}`, null, response => success(response));
  },

  // 上架、下架积分商品
  setIntegralStatus(params, success) {
    Request.PUT('/commodity/points/status', params, response => success(response));
  },

  // 新增积分商品
  addIntegral(params, success) {
    Request.POST('/commodity/points', params, response => success(response));
  },

  // 修改积分商品
  editIntegral(id, params, success) {
    Request.PUT(`/commodity/points/${id}`, params, response => success(response));
  },
};



// WEBPACK FOOTER //
// ./src/api/integralApi.js